import codes from '../../resources/error-codes.json'
import { ERROR_CODE_DEFAULT_STATE, ERROR_CODE_GENERIC_STRING } from '../../utils/constants'

export const translateError = (code, defaultError = ERROR_CODE_GENERIC_STRING) => {
  if (!code) {
    return defaultError
  }

  const error = code?.toString()
  if (error === ERROR_CODE_DEFAULT_STATE) {
    return
  }

  return codes[error] ?? defaultError
}
